/// <reference path="./window.d.ts" />
import * as lvFlandersStartschermTevredenheidsmeterNgUi from '../../../dist/@lvflanders/startscherm-tevredenheidsmeter-ng-ui';

if (window.lvflanders == null) window.lvflanders = {};
if (window.lvflanders.startscherm == null) window.lvflanders.startscherm = {};
if (window.lvflanders.startscherm.tevredenheidsmeter == null) window.lvflanders.startscherm.tevredenheidsmeter = {};
if (window.lvflanders.startscherm.tevredenheidsmeter.ng == null) window.lvflanders.startscherm.tevredenheidsmeter.ng = {};
window.lvflanders.startscherm.tevredenheidsmeter.ng.ui = lvFlandersStartschermTevredenheidsmeterNgUi;

export { lvFlandersStartschermTevredenheidsmeterNgUi };
